import {
	LocalAudioTrack,
	LocalVideoTrack,
	CreateLocalTrackOptions,
} from 'twilio-video';
import { useEffect, useRef } from 'react';
export default function useRestartAudioTrackOnDeviceChange(
	localTracks: (LocalAudioTrack | LocalVideoTrack)[],
	restartAudio?: (options: CreateLocalTrackOptions) => Promise<void>,
	restartVideo?: (options: CreateLocalTrackOptions) => Promise<void>,
	onError?: (error: Error) => void,
) {
	const attempted = useRef(new WeakSet<MediaStreamTrack>());
	useEffect(() => {
		const handleDeviceChange = () => {
			localTracks.forEach((track) => {
				const source =
					(track as LocalAudioTrack).noiseCancellation?.sourceTrack ||
					track.mediaStreamTrack;
				if (
					source.readyState !== 'ended' ||
					attempted.current.has(source)
				)
					return;
				attempted.current.add(source);
				const restart =
					track.kind === 'audio' ? restartAudio : restartVideo;
				void restart?.({}).catch(() =>
					onError?.(
						new Error(
							`Your ${track.kind === 'audio' ? 'microphone' : 'camera'} disconnected. Reconnect it and try again.`,
						),
					),
				);
			});
		};
		navigator.mediaDevices.addEventListener(
			'devicechange',
			handleDeviceChange,
		);
		return () =>
			navigator.mediaDevices.removeEventListener(
				'devicechange',
				handleDeviceChange,
			);
	}, [localTracks, restartAudio, restartVideo, onError]);
}
